import { Component, Input, OnInit } from '@angular/core';
import { PageSize } from '../../../core/dto/page.size';
import { Router } from '@angular/router';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { Pagination } from '../../../core/dto/pagination';
import { InventoryService } from '../../../core/services/inventory.service';
import * as _ from 'lodash';
import { SETTINGS } from '../../../core/config/common.settings';

@Component({
  selector: 'app-view-inventory',
  templateUrl: './view-inventory.component.html',
  styleUrls: ['./view-inventory.component.scss'],
})
export class ViewInventoryComponent implements OnInit {
  @Input() fleetData: any | undefined;

  inventoryTracker: any; //TO see which item the before information should come from
  searchText = null;
  pageSize = new PageSize();
  sortField: any;
  sortOrder: any = -1;
  inventoryData: any[] = []; // Initialize with dummy data
  breadcrumbs: any[] = [];
  dateFilter: any;

  skeletonTableColumns: any[] = [
    'Inspection No',
    'Date and Time - Before',
    'Date and Time - After',
    'Done By - Before',
    'Done By - After',
    'Reason',
    'Booking Id',
    'Fuel Level - Before',
    'Fuel Level - After',
    'Odometer - Before',
    'Odometer - After',
    'Actions',
  ];
  loading = false;
  searched = false;

  constructor(
    private router: Router,
    private inventoryService: InventoryService,
  ) {}

  ngOnInit() {
    // this.getPagedInventory();
    // jj
  }

  onTableParamsChange(params: NzTableQueryParams): void {
    this.pageSize.pageSize = params.pageSize;
    this.pageSize.pageIndex = params.pageIndex;
    this.getPagedInventory();
  }

  getPagedInventory(): void {
    this.loading = true;
    const payload = Object.assign({}, new Pagination(this.pageSize), {
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      filters: {
        dateFilter: this.dateFilter,
        searchValue: this.searchText,
        fleetId: this.fleetData?._id,
      },
    });
    this.inventoryService.getInventoryPaged(payload).then((res: any) => {
      this.loading = false;
      this.inventoryData = this.formatData(res.data);
      this.inventoryTracker = this.inventoryData.length;
      this.pageSize.length = res.totalItems;
    });
  }

  onChangeDateFilter(result: Date[]): void {
    this.searched = true;
    this.getPagedInventory();
  }

  formatData(documents: any[]): any[] {
    const initialDocs = documents.filter(
      (doc) => doc.before?.inspectionDetails?.reason === 'Initial',
    );
    const otherDocs = documents.filter(
      (doc) =>
        doc.before?.inspectionDetails?.reason !== 'Initial' &&
        doc.after?.inspectionDetails?.reason !== 'Final',
    );

    // Sort initialDocs and finalDocs
    initialDocs.sort((a, b) => a.createdAt - b.createdAt);

    // Sort otherDocs by createdAt in descending order
    otherDocs.sort((a, b) => b.createdAt - a.createdAt);

    // Concatenate the three arrays in the desired order
    return initialDocs.concat(otherDocs);
  }

  search(): void {
    this.searched = true;
    this.getPagedInventory();
  }

  resetSearch(): void {
    this.searched = false;
    this.searchText = null;
    this.dateFilter = null;
    this.getPagedInventory();
  }

  navigateNewInventory(): void {
    if (this.inventoryData.length < 1) {
      this.router.navigate([
        `admin/fleets/${this.fleetData._id}/inventory/add-edit`,
        { id: '', status: 'Initial' },
      ]);
    } else {
      let temp;
      if (this.inventoryTracker === 1) {
        temp = 0;
      } else {
        temp = 1;
      }
      this.router.navigate([
        `admin/fleets/${this.fleetData._id}/inventory/add-edit`,
        { id: '', status: 'Before', prevRecId: this.inventoryData[temp]._id },
      ]);
    }
  }

  deleteInventory(data: any): void {
    this.inventoryService.deleteInventory(data).then((res) => {
      this.ngOnInit();
    });
  }

  afterInspection(data: any): void {
    this.router.navigate([
      `admin/fleets/${this.fleetData._id}/inventory/add-edit`,
      { id: data, status: 'After' },
    ]);
  }

  finalInspection(data: any): void {
    if (this.inventoryData.length > 1) {
      this.router.navigate([
        `admin/fleets/${this.fleetData._id}/inventory/add-edit`,
        { id: data, status: 'Final', prevRecId: this.inventoryData[1]._id },
      ]);
    } else if (this.inventoryData.length === 1) {
      this.router.navigate([
        `admin/fleets/${this.fleetData._id}/inventory/add-edit`,
        {
          id: data,
          status: 'Final',
          prevRecId: this.inventoryData[0]._id,
          rec: true,
        },
      ]);
    }
  }

  navToSingle(data: any): void {
    this.router.navigate([
      `admin/fleets/${this.fleetData._id}/inventory/${data._id}`,
    ]);
  }

  hasPermission(perm: string): boolean {
    return _.includes(localStorage.getItem(SETTINGS.USER_PERMISSIONS), perm);
  }
}
